import React from 'react';

const Footer = () => <footer className="footer" style={{color:"#94939d"}}>
版权所有© 上海津石医药科技有限公司    技术支持:无锡慧方科技有限公司
</footer>

export default Footer;



// WEBPACK FOOTER //
// ./src/components/layout/Footer.js